import React from 'react'
import ErrorModal from '../../../ErrorModal'
import { FormlessJourneyProps } from '../FormlessJourney'
import { FormlessJourneyWithContinueCta } from './FormlessJourneyWithContinueCta'
import withDetectRefresh from '../../../HOC/withDetectRefresh'
import ConflictErrorModalContent from '../../../ErrorModal/ConflictErrorModalContent'

const FormlessJourneyWithContinueCtaWrapper = ({
  attribution,
  experimentName,
  lenderDetails,
  // injected props from HOC
  apiError,
  conflictError,
  redirectUrl,
  closeError
}: FormlessJourneyProps): JSX.Element => {
  return (
    <>
      {conflictError && (
        <ErrorModal ctaText="Close" onClick={closeError}>
          <ConflictErrorModalContent />
        </ErrorModal>
      )}
      {apiError && (
        <ErrorModal
          titleText="Sorry"
          ctaText="Please try again"
          onClick={closeError}
        >
          There was a problem submitting your application
        </ErrorModal>
      )}

      {!apiError && !conflictError && attribution && (
        <FormlessJourneyWithContinueCta
          redirectUrl={redirectUrl}
          source={attribution.source}
          experimentName={experimentName}
          lenderDetails={lenderDetails}
        />
      )}
    </>
  )
}

export default withDetectRefresh(FormlessJourneyWithContinueCtaWrapper)
